export default __webpack_public_path__ + "static/media/Medical_Imaging.fe709025.jpg";